import { DateTime } from "luxon";
import { adminAxiosInstance } from "./axiosInstance";

interface User {
    id: number;
    firstName: string;
    lastName: string;
    mobileNumber?: string;
    email: string;
    ownedByCustomerId?: number;
    compublishId?: string;
    picture?: string;
    updatedAt: DateTime;
    createdAt: DateTime;
    createdById: number;
    updatedById: number;
    deletedAt?: DateTime;
    compublishUrl?: string;
}

interface UsersResponse {
    data: User[];
    total: number;
}

export type Permission = 0 | 10 | 30 | 60 | 100;

export type UserType = "IP" | "LINK" | "NORMAL" | "CRAWLER";

interface Pagination {
    skip: number;
    take: number;
}

interface Sorting {
    order?: "asc" | "desc";
    orderKey?: string;
    customerId?: number[];
    permission?: Permission[];
    search?: string;
    deleted?: boolean;
    type?: UserType[];
    id?: number[];
}

interface paginationAndSorting extends Pagination, Sorting {}

const getUsers = async ({
    skip = 0,
    take = 10,
    order = "asc",
    orderKey = "id",
    customerId = [],
    permission = [],
    search = "",
    deleted,
    type,
    id = [],
}: paginationAndSorting): Promise<UsersResponse> => {
    try {
        let url = `admin/users?skip=${skip}&take=${take}&order=${order}&orderKey=${orderKey}`;
        if (permission.length > 0) {
            url += `&permission=${permission}`;
        }
        if (customerId.length > 0) {
            url += `&customerId=${customerId}`;
        }

        if (search) {
            url += `&search=${search}`;
        }
        if (deleted !== undefined) {
            url += deleted ? `&deleted=1` : "&deleted=";
        }
        if (type && type.length > 0) {
            url += `&type=${type.join(",")}`;
        }

        const filteredIds = id.filter((val) => val > 0);
        if (filteredIds.length > 0) {
            url += `&id=${filteredIds.join(",")}`;
        }

        const response = (await adminAxiosInstance.get(url)).data;
        return { data: response.data, total: response.meta.total };
    } catch (err) {
        throw new Error(`Error fetching users: ${err instanceof Error ? err.message : err}`, {
            cause: err,
        });
    }
};

const getUserById = async (id: number): Promise<User> => {
    const response = (await adminAxiosInstance.get(`admin/users/${id}`)).data;
    return response.data;
};

export { getUserById, getUsers };
export type { Pagination, Sorting, User };
